module.exports = __webpack_public_path__ + "static/partner-veeam-af3962092c5c680abd62218bd626f1ac.png";